import Email from "../../shared/email";
import Phone from "../../shared/phone";
import PropTypes from "prop-types";
import React from "react";
import ReadMore from "../../shared/read-more/";
import Social from "../../shared/social/social";

const UnlicensedMember = ({ member, memberDisplayLogic }) => {
  const colClass = memberDisplayLogic.hasPhotos
    ? "col-xs-8 col-xxs-16"
    : "col-xs-16";
  const photo =
    member.largePhoto && member.largePhoto.url ? (
      <img
        src={member.largePhoto.url}
        alt={member.displayName}
        className="profile-photo"
      />
    ) : null;
  const biography = member.biography
    ? member.biography.replace(/\n/g, "<br/>")
    : "";

  return (
    <div className="row member">
      <div className={"photo " + colClass}>{photo}</div>
      <div className={colClass}>
        <div className="member-info">
          <h3 className="member-name">{member.displayName}</h3>
          <div className="italicize">{member.title}</div>
          <div>
            <Phone number={member.primaryPhone} />
          </div>
          <div>
            <Email email={member.emailAddress} showPrefix={false} />
          </div>
          <div>
            <Social socials={member.socials} />
          </div>
        </div>
        <div className="member-bio">
          <ReadMore id={"member" + member.memberId} height={300}>
            <p dangerouslySetInnerHTML={{ __html: biography }}></p>
          </ReadMore>
        </div>
      </div>
    </div>
  );
};

UnlicensedMember.propTypes = {
  member: PropTypes.object.isRequired,
  memberDisplayLogic: PropTypes.object.isRequired,
};

export default UnlicensedMember;



// WEBPACK FOOTER //
// ./src/components/about/team/unlicensed-member.js